import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import * as Icon from 'react-bootstrap-icons';

import { Forbidden, LightButton, PrimaryButton, TextInputPreview } from '../../../components';

import styles from '../Modals.module.css';
import { colors } from '../../../types/types';

export const CitaAgendaModal = ({ cita = null, hide, atenderCita, confirmarCita, SolicitarConfirmacionCita, editarCita, cancelarCita, noPresentarCita, viewPaciente }) => {

    const { permisos } = useSelector(state => state.auth);

    return (permisos.citaRead || permisos.citaUpdate) ? (
        <>
            <div className={styles.topCloseButtonContainer}>
                <div className={styles.topCloseButton} onClick={hide}>
                    <Icon.X color={colors.DANGER} size={30} />
                </div>
                <div className="row mb-3">
                    <div className="col">
                        <div className={styles.modalHeader}>Detalles de cita</div>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <span className={"me-3 " + styles.modalFourthHeader}>{(typeof cita.paciente !== 'undefined') ? 'Paciente' : 'Paciente nuevo'}</span>
                        {(typeof cita.paciente !== 'undefined') &&
                        <span className="badge" style={{backgroundColor: cita.paciente.colorApp}}>{ cita.paciente.etiquetaApp }</span>
                        }
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <TextInputPreview
                            label="Nombre(s)"
                            name="name"
                            value={ (typeof cita.paciente !== 'undefined') ? cita.paciente.nombre : cita.datosPaciente }
                        />
                    </div>
                </div>
                {(typeof cita.paciente === 'undefined') && <>
                    <div className="row">
                        <div className="col-md-12 col-lg-6">
                            <TextInputPreview
                                label="Correo electrónico"
                                name="email"
                                value={ cita.datosCita.email }
                            />
                        </div>
                        <div className="col-md-12 col-lg-6">
                            <TextInputPreview
                                label="Celular"
                                name="celular"
                                value={ cita.datosCita.celular }
                            />
                        </div>
                    </div>
                </>}
                {(typeof cita.paciente !== 'undefined') &&
                <>
                    <div className="row">
                        <div className="col-md-12 col-lg-6">
                            <TextInputPreview
                                label="Correo electrónico"
                                name="email"
                                value={ cita.paciente.email }
                            />
                        </div>
                        <div className="col-md-12 col-lg-6">
                            <TextInputPreview
                                label="Edad"
                                name="edad"
                                value={ cita.paciente.edad }
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 col-lg-6">
                            <TextInputPreview
                                label="Teléfono fijo"
                                name="telefono"
                                value={ cita.paciente.telefono }
                            />
                        </div>
                        <div className="col-md-12 col-lg-6">
                            <TextInputPreview
                                label="Celular"
                                name="celular"
                                value={ cita.paciente.celular }
                            />
                        </div>
                    </div>
                </>
                }
                {(typeof cita.motivoConsulta !== 'undefined' && cita.motivoConsulta !== '') &&
                <div className="row">
                    <div className="col">
                        <TextInputPreview
                            label="Motivo última consulta"
                            name="motivoConsulta"
                            value={ cita.motivoConsulta }
                        />
                    </div>
                </div>
                }
                <div className="row">
                    <div className="col">
                        <span className={"me-3 " + styles.modalFourthHeader}>Cita</span>
                        <span className="badge" style={{backgroundColor: cita.colorCita}}>{ cita.etiquetaCita }</span>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12 col-lg-6">
                        <TextInputPreview
                            label="Motivo"
                            name="motivo"
                            value={ cita.motivo.nombre }
                        />
                    </div>
                    <div className="col-md-12 col-lg-6">
                        <TextInputPreview
                            label="Tipo"
                            name="isPrimeraVez"
                            value={ (cita.isPrimeraVez) ? "Primera vez" : "Subsecuente" }
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12 col-lg-6">
                        <TextInputPreview
                            label="Fecha"
                            name="dia"
                            value={ cita.dia }
                        />
                    </div>
                    <div className="col-md-12 col-lg-6">
                        <TextInputPreview
                            label="Hora"
                            name="hora"
                            value={ cita.hora }
                        />
                    </div>
                </div>
                {(typeof cita.comentario !== 'undefined' && cita.comentario !== '') &&
                <div className="row">
                    <div className="col-md-12 col-lg-6">
                        <TextInputPreview
                            label="Comentario"
                            name="comentario"
                            value={ cita.comentario }
                        />
                    </div>
                </div>
                }
                <div className="row">
                    {(permisos.citaUpdate && !cita.confirmada && !cita.atendida) &&
                    <>
                        {(typeof cita.paciente !== 'undefined' && cita.paciente.etiquetaApp === 'Enlazada')
                        ? <div className="col">
                            {/* iconMargin={2} */}
                            {/* iconSize="0.7" */}
                            {/* icon="Calendar2Plus" */}
                            <PrimaryButton
                                block={true}
                                marginTop={false}
                                onClick={ SolicitarConfirmacionCita }
                                text={<div>
                                    <div>Solicitar</div>
                                    <div>confirmación</div>
                                </div>}
                                type="button"
                            />
                        </div>
                        : <div className="col">
                            {/* iconMargin={2} */}
                            {/* iconSize="0.7" */}
                            {/* icon="CalendarCheck" */}
                            <PrimaryButton
                                block={true}
                                marginTop={false}
                                onClick={ confirmarCita }
                                text={<div>
                                    <div>Confirmar</div>
                                    <div>cita</div>
                                </div>}
                                type="button"
                            />
                        </div>}
                    </>
                    }
                    {(permisos.citaUpdate && cita.confirmada && !cita.atendida) &&
                    <div className="col">
                        {/* iconMargin={2} */}
                        {/* iconSize="0.7" */}
                        {/* icon="CalendarEvent" */}
                        <PrimaryButton
                            block={true}
                            marginTop={false}
                            onClick={ atenderCita }
                            text={<div>
                                    <div>Atender</div>
                                    <div>cita</div>
                                </div>}
                            type="button"
                        />
                    </div>
                    }
                    {(permisos.citaUpdate && cita.confirmada && !cita.atendida) &&
                    <div className="col">
                        {/* iconMargin={2} */}
                        {/* iconSize="0.7" */}
                        {/* icon="CalendarMinus" */}
                        <LightButton
                            block={true}
                            marginTop={false}
                            onClick={ noPresentarCita }
                            text={<div>
                                    <div>No presentar</div>
                                    <div>cita</div>
                                </div>}
                            type="button"
                        />
                    </div>
                    }
                    {(permisos.citaUpdate && !cita.atendida) &&
                    <div className="col">
                        {/* iconMargin={2} */}
                        {/* iconSize="0.7" */}
                        {/* icon="Calendar3" */}
                        <LightButton
                            block={true}
                            marginTop={false}
                            onClick={ editarCita }
                            text={<div>
                                    <div>Editar</div>
                                    <div>cita</div>
                                </div>}
                            type="button"
                        />
                    </div>
                    }
                    {(permisos.citaUpdate && !cita.atendida) &&
                    <div className="col">
                        {/* iconMargin={2} */}
                        {/* iconSize="0.7" */}
                        {/* icon="Calendar2X" */}
                        <LightButton
                            block={true}
                            marginTop={false}
                            onClick={ cancelarCita }
                            text={<div>
                                    <div>Cancelar</div>
                                    <div>cita</div>
                                </div>}
                            type="button"
                        />
                    </div>
                    }
                    {(permisos.pacienteRead && typeof cita.paciente !== 'undefined') && 
                    <div className="col">
                        {/* iconMargin={2} */}
                        {/* iconSize="0.7" */}
                        {/* icon="CalendarEvent" */}
                        <PrimaryButton
                            block={true}
                            marginTop={false}
                            onClick={ viewPaciente }
                            text={<div>
                                    <div>Ver</div>
                                    <div>paciente</div>
                                </div>}
                            type="button"
                        />
                    </div>
                    }
                </div>
            </div>
        </>
    ) : <Forbidden />
}

CitaAgendaModal.propTypes = {
  cita: PropTypes.object,
  hide: PropTypes.func.isRequired,
  atenderCita: PropTypes.func.isRequired,
  confirmarCita: PropTypes.func.isRequired,
  SolicitarConfirmacionCita: PropTypes.func.isRequired,
  editarCita: PropTypes.func.isRequired,
  cancelarCita: PropTypes.func.isRequired,
  noPresentarCita: PropTypes.func.isRequired,
}